import React from "react"
import { Link } from "react-router-dom"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { Box } from "components/common/index"

const PrivacyPolicy = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <SectionTitle>PRIVACY POLICY</SectionTitle>
        <Text>
          Jewlr has improved our Terms and Conditions and Privacy Policy to make
          it easier for you to understand what data we collect and what
          it&apos;s used for. Refer to the{" "}
          <Link data-lc="privacy-policy" to="/info/privacy_notice">
            Privacy Notice
          </Link>{" "}
          for more information on the General Data Protection policy and
          California Consumer Privacy Act.
        </Text>
      </Box>
    </Section>
    <Section hasBg>
      <Box contain>
        <SectionTitle>WE CARE ABOUT YOUR PRIVACY</SectionTitle>
        <Text mb={0}>
          Your privacy is important to Jewlr.com, Jewlr UK Limited and 6888887
          Canada Inc, (JEWLR), so we have created the following Privacy Policy
          to let you know what information we collect when you visit our
          website, JEWLR (the &quot;Site&quot;), why we collect it, and how it
          is used. This Privacy Policy also addresses our data security
          practices, the options you have to access and control any personally
          identifiable information you provide to us, and other matters. We may
          periodically make changes to this Privacy Policy which will be
          included on this page. It is your responsibility to review this
          Privacy Policy frequently and remain informed about any changes to it,
          so we encourage you to visit this page often. By using the Site, you
          agree to this Privacy Policy. This is our entire and exclusive Privacy
          Policy and it supersedes any earlier version.
        </Text>
      </Box>
    </Section>
    <Section>
      <Box contain>
        <SectionTitle>EMAIL</SectionTitle>
        <Text>
          When you give us your email address, or send us email correspondence,
          we retain your email address. We do not share our email lists with
          third parties for marketing purposes. We use email addresses to
          communicate with you regarding your orders and other matters regarding
          transactions between us or your customer relationship with us. We
          retain information provided by all of our customers, such as
          registration information, transaction information (e.g., dates on
          which customers made purchases, amounts and types of purchases) and
          contact information (e.g., name, address, phone number).
        </Text>
      </Box>
    </Section>
    <Section hasBg>
      <Box contain>
        <SectionTitle>SECURITY</SectionTitle>
        <Text mb={0}>
          JEWLR takes every precaution to protect our users’ information. When
          users submit sensitive information via our website, your information
          is protected both online and off-line. We use industry-standard
          encryption technologies when transferring and receiving customer data
          exchanged with our website server. Information entered into the
          registration or order form is considered sensitive information (such
          as credit card number and/or address) and that information is
          encrypted and is protected with the best encryption software in the
          industry. In addition, the servers where we store personally
          identifiable information are kept in a secure environment under
          restricted access.
        </Text>
      </Box>
    </Section>
    <Section>
      <Box contain>
        <SectionTitle>INFORMATION COLLECTION AND USE</SectionTitle>
        <Text>
          JEWLR is the sole owner of the information collected on this site. We
          will not sell, share, or rent this information to others in ways
          different from what is disclosed in this statement. JEWLR collects
          information from our users at several different points on our website.
        </Text>
        <Text>
          In addition, subject to applicable law, you have the right to request
          access to, correct, and delete your personal data, and to ask for data
          portability. You may also object to our processing of your personal
          data or ask that we restrict the processing of your personal data in
          certain instances. If you wish to do any of these things, please
          contact us at privacy@jewlr.com.
        </Text>
      </Box>
    </Section>
    <Section hasBg>
      <Box contain>
        <SectionTitle>MY ACCOUNT</SectionTitle>
        <Text mb={0}>
          When you make your first purchase on our site, you will be asked to
          create an account. By creating an account, the system will remember
          your personal and purchase information and the checkout process on
          future purchases will be fast, easy and always completely secure.
          Creating an account is also fast and easy: simply enter your personal
          information once and select your very own username and password. Then
          during checkout on your next purchase, just login and the system will
          take care of the rest.
        </Text>
      </Box>
    </Section>
    <Section>
      <Box contain>
        <SectionTitle>USAGE TRACKING</SectionTitle>
        <Text>
          JEWLR tracks the traffic throughout our site. This information is used
          to compile overall statistics and is not recorded at an individual
          level. This includes IP (internet protocol) addresses, browser type,
          ISP (internet service provider), referring/exit pages, platform type,
          date/time stamp, and # of clicks to analyze trends, administer the
          site, track user’s movement in the aggregate. These statistics help us
          decide which products and services best serve our members and guests.
        </Text>
      </Box>
    </Section>

    <Section hasBg>
      <Box contain>
        <SectionTitle>COOKIES</SectionTitle>
        <Text>
          A cookie is a piece of data stored on the user’s hard drive containing
          information about the user. We use both session and persistent
          cookies. Usage of a cookie from our site is in no way linked to any
          personally identifiable information. Cookies enable us to track and
          target the interests of our users in the aggregate by analyzing
          popular areas and products to enhance future experiences on our site.
          Cookies do not cause damage to your computer systems or files, and
          only the web site that transferred a particular cookie to you can
          read, modify or delete such cookie. If you do not want information
          collected through the use of cookies, there are simple procedures in
          most browsers that allow you to delete existing cookies, to
          automatically decline cookies, or to be given the choice of declining
          or accepting the transfer of particular cookies to your computer.
        </Text>
      </Box>
    </Section>

    <Section>
      <Box contain>
        <SectionTitle>3RD PARTY DISCLOSURE</SectionTitle>
        <Text>
          Jewlr does make use of Forter services for certain transaction types.
          Read Forter&apos;s Privacy Policy here:{" "}
          <a
            href="https://www.forter.com/services-privacy-policy/"
            rel="noreferrer noopener"
            target="_blank"
          >
            https://www.forter.com/forter-privacy-policy/
          </a>
        </Text>
      </Box>
    </Section>
  </Box>
)

export default PrivacyPolicy
